<!--A significantly simplified version of the MDB calendar with only the
    month view, and all events are clickable to bring up extra event
    information. NO editable nonsense.-->

<template>
  <div class="mdb-calendar">
    <mdb-month-view
      v-if="view === 'month'"
      :defaultDate="date"
      :dayNames="shortDayNames"
      :monthNames="monthNames"
      :todayText="todayText"
      :events="newEvents"
      @dateChange="dateChange"
      @changeView="changeView"
      @showEventInfo="showEventInfo"
    />

    <mdb-modal
      :show="modal"
      @close="modal = false"
      @keydown.esc.native="modal = false"
      size="sm"
    >
      <mdb-modal-header>
        <mdb-modal-title tag="h4"
          ><strong>{{ activeEvent.title }}</strong></mdb-modal-title
        >
      </mdb-modal-header>
      <mdb-modal-body v-if="modal" class="text-left">
        <p><strong>Event Dates: </strong></p>
        <p style="display: inline">
          {{ activeEventData.startMonth }}/{{ activeEventData.startDate }}/{{
            activeEvent.start.getFullYear()
          }}
        </p>
        <p style="display: inline" v-if="activeEventData.endDate">
          - {{ activeEventData.endMonth }}/{{ activeEventData.endDate }}/{{
            activeEvent.start.getFullYear()
          }}
        </p>
        <p v-if="activeEventData.startTime"><strong>Event Times:</strong></p>
        <p v-if="activeEventData.startTime" style="display: inline">
          {{ toTimeString(activeEventData.startTime) }}
        </p>
        <p style="display: inline" v-if="activeEventData.endTime">
          - {{ toTimeString(activeEventData.endTime) }}
        </p>
      </mdb-modal-body>
      <mdb-modal-footer>
        <router-link :to="activeEvent.link">
          <mdb-btn color="primary" btn="sm">Read More</mdb-btn>
        </router-link>
        <mdb-btn color="primary" btn="sm" @click.native="modal = false"
          >Close</mdb-btn
        >
      </mdb-modal-footer>
    </mdb-modal>
  </div>
</template>

<script>
import { orderBy } from "lodash";
import shared from "@/shared";
import { mdbMonthView } from "./mdbMonthView";
import {
  mdbModal,
  mdbModalHeader,
  mdbModalTitle,
  mdbModalBody,
  mdbModalFooter,
  mdbBtn,
  mdbInput,
} from "mdbvue";

const mdbCalendar = {
  name: "mdbCalendar",
  components: {
    mdbMonthView,
    mdbModal,
    mdbModalHeader,
    mdbModalTitle,
    mdbModalBody,
    mdbModalFooter,
    mdbBtn,
    mdbInput,
  },
  props: {
    defaultView: {
      type: String,
      default: "month",
    },
    defaultDate: {
      type: Date,
      default: () => new Date(),
    },
    monthNames: {
      type: Array,
      default: () => [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ],
    },
    shortMonthNames: {
      type: Array,
      default: () => [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ],
    },
    dayNames: {
      type: Array,
      default: () => [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
      ],
    },
    shortDayNames: {
      type: Array,
      default: () => ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
    },
    todayText: {
      type: String,
      default: "Today",
    },
    events: {
      type: [Array, Boolean],
      default: false,
    },
  },
  data() {
    return {
      view: this.defaultView,
      date: this.defaultDate,
      newEvents: orderBy(this.events, ["start", "end"], ["asc", "desc"]),
      modal: false,
      activeEvent: {},
      activeEventData: {},
    };
  },
  methods: {
    showEventInfo(eventIndex) {
      this.activeEvent = this.newEvents[eventIndex];
      this.modal = true;
    },
    changeView(view) {
      this.view = view;
    },
    dateChange(date) {
      this.date = date;
    },
    toTimeString: function (time) {
      return shared.TwelveHrTime(time);
    },
  },
  watch: {
    defaultDate(newVal) {
      this.date = newVal;
    },
    // newEvents() {
    //   this.$emit('getEvents', this.newEvents)
    // },
    activeEvent() {
      this.activeEvent.start.getDate() < 10
        ? (this.activeEventData.startDate =
            "0" + this.activeEvent.start.getDate())
        : (this.activeEventData.startDate = this.activeEvent.start.getDate());
      this.activeEvent.start.getMonth() < 10
        ? (this.activeEventData.startMonth =
            "0" + (this.activeEvent.start.getMonth() + 1))
        : (this.activeEventData.startMonth =
            this.activeEvent.start.getMonth() + 1);
      this.activeEventData.startTime = this.activeEvent.start_time;

      if (this.activeEvent.end != null) {
        this.activeEvent.end.getDate() < 10
          ? (this.activeEventData.endDate =
              "0" + this.activeEvent.end.getDate())
          : (this.activeEventData.endDate = this.activeEvent.end.getDate());
        this.activeEvent.end.getMonth() < 10
          ? (this.activeEventData.endMonth =
              "0" + (this.activeEvent.end.getMonth() + 1))
          : (this.activeEventData.endMonth =
              this.activeEvent.end.getMonth() + 1);
      } else {
        this.activeEventData.endDate = null;
        this.activeEventData.endMonth = null;
      }
      if (this.activeEvent.end_time) {
        this.activeEventData.endTime = this.activeEvent.end_time;
      } else {
        this.activeEventData.endTime = null;
      }
    },
  },
};

export default mdbCalendar;
export { mdbCalendar as mdbCalendar };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.custom-control-label {
  cursor: pointer;
}
</style>
